import { useEffect } from "react";
import { mustGetElementById, mustQuerySelectorAtIndex } from "./helpers";
import { useProxyAction } from "./useProxyAction";
import { useProxyError } from "./useProxyError";
import { useProxyErrors } from "./useProxyErrors";

const getNewPasswordInput = () => mustGetElementById<HTMLInputElement>('newPassword');
const getReenterPasswordInput = () => mustGetElementById<HTMLInputElement>('reenterPassword');

const getContinueButton = () => mustGetElementById<HTMLButtonElement>('continue');
const getCancelButton = () => mustGetElementById<HTMLButtonElement>('cancel');

export enum ItemLevelErrorIndexes {
  NewPassword = 0,
  ReenterPassword = 1,
}

const getNewPasswordError = () =>
  mustQuerySelectorAtIndex('#api .error.itemLevel', ItemLevelErrorIndexes.NewPassword, 'new password error');
const getReenterPasswordError = () =>
  mustQuerySelectorAtIndex('#api .error.itemLevel', ItemLevelErrorIndexes.ReenterPassword, 'reenter password error');
const getPageLevelErrors = () => Array.from<HTMLElement>(document.querySelectorAll('#api .error.pageLevel'));

export enum PageLevelErrorIndexes {
  RequiredFieldMissing = 0,
  OneOrMoreIncorrectFields = 1,
  ServerError = 2,
}

export function useResetPasswordProxy({ newPassword, reenterPassword } : {
  newPassword: string
  reenterPassword: string
}) {
  // fields
  useEffect(() => {
    getNewPasswordInput().value = newPassword;
  }, [newPassword]);

  useEffect(() => {
    getReenterPasswordInput().value = reenterPassword;
  }, [reenterPassword]);

  // actions
  const continueAction = useProxyAction(getContinueButton);
  const cancelAction = useProxyAction(getCancelButton);

  // errors
  const newPasswordError = useProxyError(getNewPasswordError);
  const reenterPasswordError = useProxyError(getReenterPasswordError);
  const pageLevelError = useProxyErrors(getPageLevelErrors);

  return { continueAction, cancelAction, newPasswordError, reenterPasswordError, pageLevelError };
}
